// Logo oficial de fichando.app — reloj con check (SVG vectorial, fondo transparente)
export function LogoMark({ size = 40, glow = false }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" style={glow ? { filter: "drop-shadow(0 0 6px rgba(0,224,255,0.45))" } : {}}>
      <circle cx="32" cy="32" r="29" fill="#003366" />
      <circle cx="32" cy="32" r="29" stroke="#00E0FF" strokeWidth="3" />
      {/* ticks */}
      <rect x="30.5" y="6" width="3" height="7" rx="1.5" fill="#00E0FF" />
      <rect x="30.5" y="51" width="3" height="7" rx="1.5" fill="#00E0FF" />
      <rect x="6" y="30.5" width="7" height="3" rx="1.5" fill="#00E0FF" />
      <rect x="51" y="30.5" width="7" height="3" rx="1.5" fill="#00E0FF" />
      {/* check */}
      <path d="M16 33.5 L27 45 L51 16" stroke="#FF8C00" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function Logo({ size = 40, withText = true, dark = false, tagline = false, textSize = "text-xl", glow = false }) {
  const wordColor = dark ? "#FFFFFF" : "#003366";
  const tagColor = dark ? "#7FE9F5" : "#1796B0";
  return (
    <div className="flex items-center gap-2.5">
      <LogoMark size={size} glow={glow} />
      {withText && (
        <div className="leading-none">
          <span className={`font-heading font-extrabold tracking-tight ${textSize}`} style={{ color: wordColor }}>
            fichando<span style={{ color: "#FF8C00" }}>.app</span>
          </span>
          {tagline && <div className="text-[10px] font-semibold tracking-wide mt-0.5" style={{ color: tagColor }}>Control Horario Inteligente</div>}
        </div>
      )}
    </div>
  );
}
